<template lang="html">
  <section :id="id">
    <base-modal
      ref="baseModal"
      :maxHeight="maxHeight"
      @on-base-modal-close="cancelModal"
    >
      <!-- header  -->
      <template v-slot:header>
        <div class="m-title">
          {{ getMessageText(messages.DISP_EL_SECTION) }}
        </div>
      </template>

      <!-- content  -->
      <div class="m-items" v-if="isModalDataSet">
        <element-description
          :label="descriptionText"
          :outer-container-class="'m-selection'"
          :label-class="'selection-label'"
          :elem-description="desc"
          :focus="true"
          @on-element-description-changed="onDeDescriptionChanged"
        ></element-description>
      </div>

      <div class="m-items">
        <div class="m-selection checkbox-wrapper stack-checkbox">
          <label
            class="no-margin cursor-pointer"
            @click="toggleIncludeHeader"
            >{{ includeHeaderText }}</label
          >
          <b-form-checkbox v-model="includeTitle"></b-form-checkbox>
        </div>

        <div class="m-selection" v-if="includeTitle">
          <label class="selection-label">
            {{ getMessageText(messages.ICON_INPUT) }}:
          </label>
          <search-box-icons
            id="selectIcon"
            :value="iconValue"
            @on-search-box-icon-selected="onIconSelected"
          />
        </div>
        <div v-if="includeTitle">
          <div class="m-selection">
            <div class="selection-label">
              {{ getMessageText(messages.TITLE_INPUT) }}:
            </div>
            <expressions
              class="section-content"
              id="expression"
              :data-elements="allSources"
              :data-type="'string'"
              :initial-expression="expressionValue"
              :is-global="true"
              :content-type="appContent.type"
              @on-expression-field-valid="onConfigExpressionValid"
            />
          </div>

          <div class="m-selection" v-if="isModalDataSet">
            <div class="selection-label"></div>
            <user-action
              class="section-content"
              :all-sources="allSources"
              :is-global="true"
              :data-type="'string'"
              :action="action"
              :app-id="appId"
              @on-user-action-change="onUserActionChange"
            />
          </div>
        </div>
      </div>

      <!-- footer  -->
      <template v-slot:footer>
        <div class="m-group-btns">
          <button class="m-button neutral" @click="cancelModal">
            {{ getMessageText(messages.CANCEL) }}
          </button>
          <button
            class="m-button brand"
            @click="createBtn"
            :disabled="isSubmitDisabled"
          >
            {{ getMessageText(messages.OK) }}
          </button>
        </div>
      </template>
    </base-modal>
  </section>
</template>

<script lang="js">
  import store from "@/store";
  import expressionBuilder from "@/views/drag-drop-pages/components/utils/expression-builder";
  import dragAndDrop from "@/views/drag-drop-pages/components/utils/dragAndDrop";
  import BaseModal from "@/views/drag-drop-pages/components/modal/BaseModal";
  import SearchBoxIcons from "@/views/drag-drop-pages/components/searchbox/searchicons/SearchBoxIcons";
  import Expressions from "@/components/Expressions"
  import UserAction from "@/views/drag-drop-pages/components/builder/modal/UserAction";
  import ElementDescription from "@/components/ElementDescription";
  import utils from "@/utils";

  export default  {
    name: "add-card-modal",
    components: {
      BaseModal,
      SearchBoxIcons,
      Expressions,
      UserAction,
      ElementDescription
    },
    props: {
      id: {
        type: String
      },
      maxHeight: {
        type: Number
      },
      editData: {
        type: Object
      }
    },
    watch: {
      includeTitle: function(){
        if(!this.includeTitle) {
          this.expressionValue = null;
          this.iconValue = null;
          this.action = null;
        }
      }
    },
    computed: {
      messages() {
        return store.state.messages;
      },
      includeHeaderText() {
        return this.getMessageText(this.messages.INCLUDE_HEADER);
      },
      appId() {
        return dragAndDrop.getAppId();
      },
      appContent() {
        return JSON.parse(JSON.stringify(expressionBuilder.getAppContent(this.appId)));
      },
      allSources() {
        let output = null;
        if (this.appContent) {
          output = this.appContent.dataElements || {};
        } else {
          console.error(`No app content found for appId ${this.appId}`);
        }
        return output;
      },
      isSubmitDisabled() {
        return this.includeTitle && (!this.expressionValue || !utils.isValidAction(this.action));
      },
      desc() {
        return this.editData ? this.editData.props.description : "";
      },
      descriptionText() {
        return this.getMessageText(this.messages.DESCRIPTION);
      }
    },
    mounted () {
      if(this.editData) {
        this.setupEditModalData(this.editData);
      }
      this.isModalDataSet = true;
    },
    data () {
      return {
        includeTitle: true,
        iconValue: null,
        expressionValue: null,
        action: null,
        elementDescription: null,
        isModalDataSet: false
      }
    },
    methods: {
      toggleIncludeHeader() {
        this.includeTitle = !this.includeTitle;
      },
      onIconSelected(ctx) {
        this.iconValue = ctx? ctx.icon : null;
      },
      onConfigExpressionValid(ctx) {
        this.expressionValue = ctx.status? ctx.confExpression : null;
      },
      cancelModal() {
        const EVENT = "on-add-modal-close";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          dragAndDrop.makeAllComponentsDraggable();
          this.$emit(EVENT, {id: this.id});
        }
      },
      createBtn() {
        const obj = {
          modal: {
            id: this.id,
            create: "CardLayout",
            editElementId: this.editData? this.editData.id: null
          },
          props: {
            description: this.elementDescription,
            headerContent: {
              expression: this.expressionValue,
              icon: this.iconValue,
              action: this.action
            }
          }
        };
        const EVENT = "on-add-modal-done";
        if(this.$listeners[EVENT] || this._events[EVENT]) {
          dragAndDrop.makeAllComponentsDraggable();
          this.$emit(EVENT, obj);
        }
      },
      setupEditModalData(editData) {
        const headerContent = editData.props.headerContent;
        this.onDeDescriptionChanged(editData.props.description)
        if(Object.keys(headerContent).length) {
          this.iconValue = headerContent.icon;
          if(headerContent.expression && Object.keys(headerContent.expression).length) {
            this.expressionValue = headerContent.expression;
          }
          this.action = headerContent.action;
        }
        this.includeTitle = Boolean(this.iconValue || this.expressionValue);
      },
      onUserActionChange(ctx) {
        this.action = ctx;
      },
      onDeDescriptionChanged(input) {
        this.elementDescription = input;
      }
    }
  }
</script>

<style scoped lang="scss">
  @import "@/styles/components/main";
  @include drag-drop-a-tag;
  .m-items {
    display: flex;
    flex-direction: column;
    padding: 0 10px 0;
    .m-selection {
      border-width: 0;
      display: flex;
      flex-direction: column;
      box-sizing: border-box;
      margin-bottom: 10px;
      .selection-label {
        align-self: flex-start;
      }
      .section-content {
        flex-basis: 100%;
      }
    }
  }

  .m-title {
    text-align: left;
  }
</style>
